import { apiClient } from './apiClient';

export interface ImportResponse {
  importedCount: number;
  errorCount: number;
  errors: string[];
}

export const importService = {
  // Скачать шаблон для импорта контрагентов
  downloadCounterpartiesTemplate: async (companyId: string, format: 'csv' | 'excel' = 'csv'): Promise<Blob> => {
    const response = await apiClient.get(
      `/companies/${companyId}/import/counterparties/template?format=${format}`,
      { responseType: 'blob' }
    );
    return response.data;
  },

  // Скачать шаблон для импорта банковских счетов
  downloadBankAccountsTemplate: async (companyId: string, format: 'csv' | 'excel' = 'csv'): Promise<Blob> => {
    const response = await apiClient.get(
      `/companies/${companyId}/import/bank-accounts/template?format=${format}`,
      { responseType: 'blob' }
    );
    return response.data;
  },

  // Импортировать контрагентов
  importCounterparties: async (companyId: string, file: File): Promise<ImportResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/companies/${companyId}/import/counterparties`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Импортировать банковские счета
  importBankAccounts: async (companyId: string, file: File): Promise<ImportResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/companies/${companyId}/import/bank-accounts`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
};

